import { IChannelRepository } from '../../ports/IChannelRepository';

export class DeleteChannelUseCase {
  constructor(private repo: IChannelRepository) {}
  execute(uuid: string) { return this.repo.delete(uuid); }
}
